import { render } from "./WeatherNextDays.vue?vue&type=template&id=72a63039"
import script from "./WeatherNextDays.vue?vue&type=script&lang=js"
export * from "./WeatherNextDays.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__